import styles from './terms.module.css'
import ConvertHTMLString from '../../components/shared/ConvertHTMLString'
import { termscond } from './termscond'
import { Helmet } from 'react-helmet'
import Header from 'components/Header/header'

const TermsandCondition = () => {

  return (
    <>
    <Helmet>
    <title>Terms &amp; Conditions iACST | Scholarships Exam</title>
    </Helmet>
      {/* --------------------------------------- */} 
      <div className={`dialog-off-canvas-main-canvas ${styles.head_sec_item_top}`} data-off-canvas-main-canvas="">
        <Header showmobile={"false"}/>
        {/* ______________________ MAIN _______________________ */}
        <div id="main" className='container allitem'>
          <div id="content-wrapper">
            <section id="content">
              <div id="content-header">
                <div id="highlighted">
                  <div>
                    <div data-drupal-messages-fallback="" className="hidden" />
                  </div>
                </div>
              </div>
              <div id="content-area">
                <div>
                  <div id="block-anthe-content">
                    <article
                      role="article"
                      about="/iacst-scholarship/terms-conditions"
                      className="node"
                    >
                      <div className="content">
                        <div>
                          <div>
                            <h4 className={`${styles.head_sec_item}`}
                            >
                              <b>Terms and Conditions for Instant Admission Cum
                                Scholarship Test (iACST)</b>
                            </h4>
                            <ol>
                              {termscond.map((obj, index) => {
                                return (
                                  <li className={`${styles.terms_point}`}>
                                  <ConvertHTMLString
                                  content={obj.cardbodyitem}
                              />
                              </li>
                                )
                              }
                              )
                              }
                            </ol>
                            {/* <p>
                              The student/ parent/ guardian hereby agree that the
                              Company may use name, photographs, videos of me and/or
                              my child for publicity in all kinds of media. In
                              addition, AESL also reserves the right to record
                              video-audio testimonial of me and/or my child for the
                              purpose of referencing or promotion, as required by the
                              Company before or after the iACST exam is conducted for
                              the purpose of publicity in all kinds of media.
                            </p> */}
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}
export default TermsandCondition